import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Router from './Router';

function mapStateToProps({ cms }) {
  const { urls } = cms;

  return {
    cmsUrls: urls,
  };
}

// withRouter ensures that the Switch receives updates despite being wrapped by Redux
// This solution found at https://github.com/facebook/react/issues/9214#issuecomment-353161691
export default withRouter(connect(mapStateToProps)(Router));
